import React from "react";
import "./UaeAbout.css";
import UaeAboutHead from "./UaeAboutHead";
import UaeAboutMain from "./UaeAboutMain";
const UaeAbout = () => {
  return (
    <div className="uaeAboutUsContainer">
      <UaeAboutHead head="About UAE Attestation" />
      <UaeAboutMain />
    </div>
  );
};

export default UaeAbout;
